module.exports = __webpack_public_path__ + "img/grid_map_menu_default.34f67840.svg";